import Vue from 'vue';
import App from './App';
import router from './router';
require('es6-promise').polyfill();
import 'babel-polyfill';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import './assets/iconfont/iconfont.css';
import moment from 'moment';
import store from './store';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)

})

Vue.config.productionTip = false;
/* eslint-disable no-new */

Vue.use(ElementUI)

ElementUI.Dialog.props.closeOnClickModal.default = false;
// Vue.use(VueViewer)
Vue.use(VueViewer, {
    defaultOptions: {
        zIndex: 9999,
    }
})

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        sessionStorage.removeItem('login');
    }
    const LOGIN = JSON.parse(sessionStorage.getItem('login'));
    if (!LOGIN && to.path !== '/login') {
        next({ path: '/login' })
    } else {
        next();
    }
})

router.onError((err) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = err.message.match(pattern);
    if (isChunkLoadFailed) {
        let chunkBool = sessionStorage.getItem('chunkError');
        let nowTimes = Date.now();
        if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) { //路由跳转报错,href手动跳转
            sessionStorage.setItem('chunkError', 'reload');
            const targetPath = router.history.pending.fullPath;
            window.location.href = window.location.origin + targetPath;
        } else if (chunkBool === 'reload') { //手动跳转后依然报错,强制刷新
            sessionStorage.setItem('chunkError', Date.now());
            window.location.reload(true);
        } else {
            console.log(err);
        }
    }
});

//解决ie，11兼容问题
if (
    '-ms-scroll-limit' in document.documentElement.style &&
    '-ms-ime-align' in document.documentElement.style
) { // detect it's IE11
    window.addEventListener("hashchange", function(event) {
        var currentPath = window.location.hash.slice(1);
        if (store.state.route.path !== currentPath) {
            router.push(currentPath)
        }
    }, false)
}

//后置守卫
router.afterEach((to, from) => {
    if (store.getters.isMobile) {
        if (store.getters.isTopSideMenu) {
            store.commit('SET_TOP_SIDE_MENU')
        }
    }
});


new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js